import ColaboradoresView from "../../components/rh/ColaboradoresView";

export default function ColaboradoresRh() {
  return <ColaboradoresView />;
}
